function updateCartItemQuantity(variantId, quantity) {
  // Implement this function based on how you're storing and rendering cart items
  // For example, find the cart item by variantId and update its quantity display
}
function recalculateCartDiscounts() {
    const cartItemsDiv = document.querySelector('.cart__items');
    const discountItems = cartItemsDiv ? cartItemsDiv.querySelectorAll('.cart-item-discount') : [];
    let totalCartDiscount = 0;

    if (discountItems.length > 0) {
        // Retrieve the discount title from the first item
        const discountTitle = discountItems[0].getAttribute('data-discount-cart-title');
        discountItems.forEach(item => {
            const cartDiscount = parseFloat(item.getAttribute('data-cart-discount'));
            totalCartDiscount += cartDiscount;
        });

        // Update the rabatt-title with the discountTitle
        const rabattTitleSpan = document.querySelector('.rabatt-title');
        if (rabattTitleSpan) rabattTitleSpan.textContent = discountTitle;

        // Format the total discount to include the currency symbol and match the theme's currency format
        // Note: Assuming that theme.Currency.formatMoney expects values in the smallest currency unit (e.g., cents)
        const formattedDiscount = theme.Currency.formatMoney(-totalCartDiscount * 100, theme.settings.moneyFormat);
        
        // Update the cart-discount-total with the formatted total cart discounts
        const cartDiscountTotalSpan = document.querySelector('.cart-discount-total');
        if (cartDiscountTotalSpan) cartDiscountTotalSpan.innerHTML = formattedDiscount;

        // Ensure the cart-footer-savings is visible
        const cartFooterSavings = document.querySelector('.cart-footer-savings');
        const cartSub = document.querySelectorAll('.cart__item-sub');
        // Loop through each element
        cartSub.forEach((item) => {
            item.classList.add('long-text');
        });
        
        if (cartFooterSavings) cartFooterSavings.style.display = ''; // Default display (usually 'block' for div)
    } else {
        // No discount items found, hide the cart-footer-savings section
        const cartFooterSavings = document.querySelector('.cart-footer-savings');
        if (cartFooterSavings) cartFooterSavings.style.display = 'none'; // Remove from layout
    }
}
// Function to attach or reattach the observer to '.cart__items' to ensure it's always correctly observing for changes
function attachObserverToCartItems() {
    // Ensure the observer is disconnected before reattaching to handle dynamic content updates
    observer.disconnect();

    // Attempt to select the '.cart__items' element
    const cartItemsDiv = document.querySelector('.cart__items');
    
    // If '.cart__items' exists, observe it for attribute changes, specifically looking at 'data-cart-subtotal'
    if (cartItemsDiv) {
        observer.observe(cartItemsDiv, {
            attributes: true, // Only observe changes to attributes
            attributeFilter: ['data-cart-subtotal'] // Specifically observe changes to 'data-cart-subtotal'
        });
    }
}
// Dedicated function to handle drawer state changes and recalculate discounts
function handleDrawerStateChange() {
    setTimeout(() => {
        recalculateCartDiscounts();
        // Ensure the cart items observer is correctly attached whenever the drawer is opened
    }, 500); // Delay to ensure dynamic content has loaded
  observeSubtotalChanges();
}


// Observer for the <html> element to detect when the drawer is opened
const drawerObserver = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
        if (mutation.attributeName === "class") {
            const hasDrawerOpened = document.documentElement.classList.contains('js-drawer-open');
            if (hasDrawerOpened) {
                handleDrawerStateChange();
            }
        }
    });
});

// Start observing the <html> element for class changes related to drawer state
drawerObserver.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class'],
});

function observeSubtotalChanges() {
    const subtotalDiv = document.querySelector('div[data-subtotal]');

    // Function to call when changes are observed
    const subtotalChangeCallback = () => {
       // console.log('Subtotal content changed.');
        // Add the function call to recalculate discounts here
        recalculateCartDiscounts();
    };

    if (subtotalDiv) {
        // Creating an observer instance
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                // Check for added or removed nodes in mutations to detect content changes
                if (mutation.type === 'childList' || mutation.type === 'subtree') {
                    // console.log('Detected change inside <div data-subtotal>.');
                    subtotalChangeCallback();
                }
            });
        });

        // Configuration of the observer:
        // childList = true to observe direct children changes
        // subtree = true to observe all descendants changes
        // characterData = true to observe changes to text content
        const config = { childList: true, subtree: true, characterData: true };

        // Pass in the target node and the observer options
        observer.observe(subtotalDiv, config);
    } else {
        console.log('<div data-subtotal> not found.');
    }
}

// You might want to call this function to start observing when the document is ready
// or after you've confirmed the existence of the target <div>
observeSubtotalChanges();
